import {
    Box,
    Grid
  } from "@mui/material";
import RealtimeProductTable from "../../components/cosmeticRank/realtimeCommerce/realtimeProductTable.jsx";
// import ProductTrendChart from "../components/ProductTrendChart.jsx";
import CustomDatePicker from "../../components/CustomDatePicker";
import { CustomMultiSelect } from "../../components/CustomMultiSelect.jsx";
import { CustomSingleSelect } from "../../components/CustomSingleSelect";
import { useState, useRef, useEffect, useCallback} from 'react';
import { useOutletContext } from "react-router-dom";
import { API_BASE_URL } from "../../config/apiDefaultPath.js";
import { backendApiCall } from "../../utils/apiCall.js";


function RankTrendOliveyoung() {

  // 공통 변수
    const today = new Date();

  /**
   * product table 
   **/
    const [selectedTableDate, setSelectedTableDate] = useState(today);
    const [selectedCategoryType, setSelectedCategoryType] = useState(["전체"]);
    const [selectedCategory, setSelectedCategory] = useState(["전체"]);
    const [selectedRank, setSelectedRank] = useState([1]);

    const inputRefTableDate = useRef();

    const [isLoading, setIsLoading] = useState(true);
    const [isCategoryTypeBoxLoading, setIsCategoryTypeBoxLoading] = useState(false);
    const [isCategoryBoxLoading, setIsCategoryBoxLoading] = useState(false);
    const [isRankBoxLoading, setIsRankBoxLoading] = useState(false);

    const [categoryTypeOptions, setCategoryTypeOptions] = useState([]);
    const [categoryOptions, setCategoryOptions] = useState([]);
    const [rankOptions, setRankOptions] = useState([]);

    const [products, setProducts] = useState([]);

    const { token } = useOutletContext();
    // const token = getIdToken(user, true);

    const backendApiCallWithToken = useCallback(
        (apiPath, body, setFn, setLoadingFn) =>
            backendApiCall(apiPath, body, setFn, setLoadingFn, token, API_BASE_URL),
        [token]
    );

    // category type 드롭박스 데이터 API 호출
    useEffect(() => {
        backendApiCallWithToken(
          "realtime/selectbox/CategoryType",
          JSON.stringify({
            selectedTableDate: selectedTableDate
          }),
          setCategoryTypeOptions,
          setIsCategoryTypeBoxLoading
        );
    }, [
      backendApiCallWithToken,
      selectedTableDate
    ]);

    // category 드롭박스 데이터 API 호출
    useEffect(() => {
        if (selectedCategoryType.length > 0){
            backendApiCallWithToken(
            "realtime/selectbox/Category",
            JSON.stringify({
              selectedTableDate: selectedTableDate,
              selectedCategoryType: selectedCategoryType
            }),
            setCategoryOptions,
            setIsCategoryBoxLoading
          );
        }
    }, [
      backendApiCallWithToken,
      selectedTableDate,
      selectedCategoryType
    ]);

    // rank 드롭박스 데이터 API 호출
    useEffect(() => {
        if (
          selectedCategoryType.length > 0
          && selectedCategory.length > 0
        ){
           backendApiCallWithToken(
            "realtime/selectbox/Rank",
            JSON.stringify({
              selectedTableDate: selectedTableDate,
              selectedCategoryType: selectedCategoryType,
              selectedCategory: selectedCategory
            }),
            setRankOptions,
            setIsRankBoxLoading
          );
        }
    }, [
      backendApiCallWithToken,
      selectedTableDate,
      selectedCategoryType,
      selectedCategory
    ]);

    // 상품리스트 테이블 데이터 API 호출
    useEffect(() => {
        if (
          selectedCategoryType.length > 0
          && selectedCategory.length > 0
          && selectedRank.length > 0
        ){
          backendApiCallWithToken(
            "realtime/products", 
            JSON.stringify({
              selectedTableDate: selectedTableDate,
              selectedCategoryType: selectedCategoryType,
              selectedCategory: selectedCategory,
              selectedRank: selectedRank
            }),
            setProducts,
            setIsLoading
          );
        }
    }, [
      backendApiCallWithToken,
      selectedTableDate,
      selectedCategoryType,
      selectedCategory,
      selectedRank
    ]);

  return (
    <div>
      <Box sx={{ px: 0, py: 0 }}>
        {/* 검색창 공간 확보용 */}
        <Box
          width="1565px"
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          p={2}
          border="1px solid #e0e0e0"
          borderBottom="none"
          borderRadius="8px 8px 0 0"
          position="sticky"
          top={0}
          zIndex={2}
          bgcolor="#fff"
        >
          <Box>
            <Grid container spacing={0.3}>
              {/* 날짜 필터 */}
              <Grid item xs={12} sm={6}>
                <CustomDatePicker 
                  selectedDate={selectedTableDate}
                  setSelectedDate={setSelectedTableDate}
                  inputRef={inputRefTableDate}
                  label="조회 기준일"
                />
              </Grid>
              {/* 카테고리 타입 필터 */}
              <Grid item xs={12} sm={6}>
                <Box
                  sx={{
                    opacity: isCategoryTypeBoxLoading ? 0.4 : 1,
                    pointerEvents: isCategoryTypeBoxLoading ? "none" : "auto",
                    transition: "opacity 0.3s ease",
                  }}
                >
                  <CustomMultiSelect
                    label="카테고리 구분"
                    labelId="type-category-1"
                    optionItems={categoryTypeOptions}
                    selectedValue={selectedCategoryType}
                    onChange={setSelectedCategoryType}
                    width="104px"
                  />
                </Box>
              </Grid>
              {/* 메인 카테고리 필터 */}
              <Grid item xs={12} sm={6}>
                <Box
                  sx={{
                    opacity: isCategoryBoxLoading ? 0.4 : 1,
                    pointerEvents: isCategoryBoxLoading ? "none" : "auto",
                    transition: "opacity 0.3s ease",
                  }}
                >
                  <CustomMultiSelect
                    label="카테고리 메인"
                    labelId="main-category-1"
                    optionItems={categoryOptions}
                    selectedValue={selectedCategory}
                    onChange={setSelectedCategory}
                    width="104px"
                  />
                </Box>
              </Grid>
              {/* 순위 필터 */}
              <Grid item xs={12} sm={6}>
                <Box
                  sx={{
                    opacity: isRankBoxLoading ? 0.4 : 1,
                    pointerEvents: isRankBoxLoading ? "none" : "auto",
                    transition: "opacity 0.3s ease",
                  }}
                >
                  <CustomSingleSelect
                    label="순위"
                    labelId="rank-"
                    optionItems={rankOptions}
                    selectedValue={selectedRank}
                    onChange={setSelectedRank}
                    width="104px"
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Box>
        <Box
          width="1565px"
          elevation={0}
          sx={{
            border: "1px solid #e0e0e0",
            borderTop: "none", // 여기 핵심
            borderRadius: "0 0 8px 8px",
            // maxHeight: "50vh",
            height: "770px",
            overflowY: "auto",
            overflowX: 'hidden'
          }}
        >
          {/* 상품 테이블 */}
          <RealtimeProductTable
            products={products}
            // selectedProducts={selectedTrendProduct}
            // onToggle={toggleProduct}
            isLoading={isLoading}
          />
        </Box>
      </Box>
    </div>
  );
}

export default RankTrendOliveyoung;
